import { EntidadTicketEnum } from "../models/EntidadTicketEnum";

/**
 * Construye `RefEntidadesAsociadas` a partir de la fila seleccionada en el grid de operación/trámite.
 */
export function refEntidadesDesdeOperacionSeleccion(operacion: any): string[] {
  if (operacion.IdBorrador === undefined) {
    return [`${EntidadTicketEnum.Operacion}:${operacion.Id}?tipo=ENERGIA`];
  }
  let tipoSuministro = operacion.TipoSuministro[0];
  if (tipoSuministro === "LUZ" || tipoSuministro === "GAS") {
    tipoSuministro = "ENERGIA";
  }
  if (operacion.IdOperacion === null) {
    return [`${EntidadTicketEnum.Borrador}:${operacion.IdBorrador}?tipo=${tipoSuministro}`];
  }
  return [`${EntidadTicketEnum.Operacion}:${operacion.IdOperacion}?tipo=${tipoSuministro}`];
}

export function refEntidadesDesdeFacturaSeleccion(factura: { Id: string }): string[] {
  return [`${EntidadTicketEnum.Factura}:${factura.Id}`];
}
